import { render, staticRenderFns } from "./ProductAttribute.vue?vue&type=template&id=5e251d2e&"
import script from "./ProductAttribute.vue?vue&type=script&lang=js&"
export * from "./ProductAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e251d2e')) {
      api.createRecord('5e251d2e', component.options)
    } else {
      api.reload('5e251d2e', component.options)
    }
    module.hot.accept("./ProductAttribute.vue?vue&type=template&id=5e251d2e&", function () {
      api.rerender('5e251d2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/themes/default/components/core/ProductAttribute.vue"
export default component.exports